export default "__VITE_ASSET__a09fe5bc__"